// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.rewards.GetRewardsUpsellWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  GetRewardsUpsellWebApiHandler_getRewardsUpsell,
  GetRewardsUpsellWebApiHandler_getRewardsUpsell_Path,
} from '@zg-rentals/ts-rent-payment-client';

import type { GetRewardsUpsellWebApiResponseDto } from '@zg-rentals/ts-rent-payment-client';

export type GetRewardsUpsellWebApiHandler_getRewardsUpsell_Options = UseQueryOptions<
  GetRewardsUpsellWebApiResponseDto,
  unknown,
  GetRewardsUpsellWebApiResponseDto,
  readonly [string]
>;

const GetRewardsUpsellWebApiHandler_getRewardsUpsell_GetKey = () =>
  [GetRewardsUpsellWebApiHandler_getRewardsUpsell_Path] as const;

export const GetRewardsUpsellWebApiHandler_getRewardsUpsell_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: GetRewardsUpsellWebApiHandler_getRewardsUpsell_GetKey(),
    queryFn: () => GetRewardsUpsellWebApiHandler_getRewardsUpsell(httpClient),
  }) as const satisfies QueryOptions;

/**
 * get rewards upsell card display
 */
export const useGetRewardsUpsellWebApiHandler_getRewardsUpsell = ({
  httpClient,
  ...options
}: Omit<GetRewardsUpsellWebApiHandler_getRewardsUpsell_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...GetRewardsUpsellWebApiHandler_getRewardsUpsell_queryOptions({ httpClient }),
    ...options,
  });
};
useGetRewardsUpsellWebApiHandler_getRewardsUpsell.getKey = GetRewardsUpsellWebApiHandler_getRewardsUpsell_GetKey;
